import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { borderRadius } from '@twisto/styles'

export const root = (theme: Theme) => css`
  background: ${theme.palette.background.secondary};
`

export const endSection = (theme: Theme) => css`
  border-start-start-radius: ${borderRadius.xl};
  border-start-end-radius: ${borderRadius.xl};
  background: ${theme.palette.background.primary};
`
